import { render, staticRenderFns } from "./AccreditationSignature.vue?vue&type=template&id=5104e6c7&scoped=true&"
import script from "./AccreditationSignature.vue?vue&type=script&lang=js&"
export * from "./AccreditationSignature.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationSignature.vue?vue&type=style&index=0&id=5104e6c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104e6c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
